import { jsx as o } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import m from "../../../../../core/Context/useCoreContext.js";
import { Image as s } from "../../../../internal/Image/Image.js";
import { Tag as t } from "../../../../internal/Tag/Tag.js";
import { TagVariant as p } from "../../../../internal/Tag/types.js";
import { TypographyVariant as T } from "../../../../internal/Typography/types.js";
import f from "../../../../internal/Typography/Typography.js";
import { useResponsiveViewport as l, mediaQueries as n } from "../../../../../hooks/useResponsiveViewport.js";
import { parsePaymentMethodType as _ } from "../utils.js";
import { PAYMENT_METHOD_CLASS as g, PAYMENT_METHOD_LOGO_CONTAINER_CLASS as N, PAYMENT_METHOD_LOGO_CLASS as O } from "./constants.js";
import { Fragment as E } from "../../../../../external/preact/dist/preact.module.js";
const V = ({
  paymentMethod: r,
  bankAccount: i
}) => {
  const { i18n: a } = m(), e = l(n.down.xs);
  return /* @__PURE__ */ o("div", { className: g, children: r || i ? /* @__PURE__ */ o(E, { children: [
    /* @__PURE__ */ o("div", { className: N, children: /* @__PURE__ */ o(
      s,
      {
        name: r ? r.type : "bankTransfer",
        alt: r ? r.type : "bankTransfer",
        folder: "logos/",
        className: O
      }
    ) }),
    /* @__PURE__ */ o(f, { variant: T.BODY, stronger: e, children: r ? _(r) : i == null ? void 0 : i.accountNumberLastFourDigits })
  ] }) : /* @__PURE__ */ o(t, { label: a.get("noData"), variant: p.LIGHT_WITH_OUTLINE }) });
};
export {
  V as default
};
